<template>
    <v-card v-if="trainerId" class="pa-2 ma-0" :class="$vuetify.theme.dark ? 'transparent03--dark' : 'transparent03'">
        <TrainerBlock
            key="trainer"
            :reverse="reverse"
            :trainer-id="trainerId"
            :obstacle-view="obstacleView"
        />
    </v-card>
</template>

<script>
    import {mapGetters} from 'vuex';
    import TrainerBlock from "@/components/trainer/TrainerBlock";
    // import {API_ENTRYPOINT} from "@/config/entrypoint";

    export default {
        components: {TrainerBlock},
        props: {
          trainerId: {Number, default: null},
          reverse: {Boolean, default: false},
          obstacleView: {Boolean, default: false},
        },
        computed: {
            ...mapGetters({
                user: 'user/item',
            }),
        },
    }
</script>

